import { useState } from "react";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { hasModule, firstAllowedRoute } from "@/lib/auth";
import { IntakeBak } from "@/features/intake/IntakeBak";
import { openIntakeWindow } from "@/features/intake/intakeWindow";

// Transport → Invoerbak (docs/invoerbak.md §3): the bak as a panel, for who has one screen or whose browser holds the
// window back; *Los* opens it as a window for the second screen. Behind order_intake: the admins first.
export const Route = createFileRoute("/_shell/intake/")({
  beforeLoad: ({ context }) => {
    if (context.session.roles.includes("admin") || hasModule(context.session, "order_intake")) return;
    throw redirect({ to: firstAllowedRoute(context.session) });
  },
  component: IntakeScreen,
});

function IntakeScreen() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [refused, setRefused] = useState(false);
  return (
    <div data-screen-label="Back-office Intake" className="wl-page wl-vstack" style={{ gap: "var(--space-3)", alignItems: "stretch", maxWidth: "760px" }}>
      <div className="wl-hstack" style={{ gap: "8px", alignItems: "center" }}>
        <span className="t-caption t-muted">{t("intake.panelHelp")}</span>
        <span className="wl-spacer" />
        <button type="button" className="wl-btn wl-btn--secondary wl-btn--sm" title={t("intake.windowHelp")} onClick={() => setRefused(openIntakeWindow() === null)}>
          {t("intake.window")}
        </button>
      </div>
      {refused && (
        <div className="wl-alert wl-alert--warning" role="status">
          <span>{t("intake.windowRefused")}</span>
        </div>
      )}
      <div style={{ height: "calc(100vh - 220px)", minHeight: "420px" }}>
        <IntakeBak onOpen={(id) => void navigate({ to: "/intake/$id", params: { id } })} onOpenOrder={(id) => void navigate({ to: "/orders/$id", params: { id } })} />
      </div>
    </div>
  );
}
